import { render, staticRenderFns } from "./EditDemoBalanceModal.vue?vue&type=template&id=2dbfad06&scoped=true&"
import script from "./EditDemoBalanceModal.vue?vue&type=script&lang=js&"
export * from "./EditDemoBalanceModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDemoBalanceModal.vue?vue&type=style&index=0&id=2dbfad06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbfad06",
  null
  
)

export default component.exports